<ng-container *transloco="let t;">
    <div class="role-active-fields-template-page py-2 px-2" >
        <div class="card-body e-form-template-page">
            <form [formGroup]="form" *ngIf="form && template_roles">
                <ng-container formArrayName="template_roles">
                    <ng-container *ngFor="let role of template_roles?.controls; let i = index" [formGroupName]="i">
                        <h4 class="card-title font-small-3" *ngIf="role?.value">{{role.value.role_name}}</h4>
                        <ng-container formArrayName="personfields">
                            <div class="row mt-1">
                                <ng-container *ngFor="let personfieldsForm of role?.get('personfields')?.['controls']; let j = index" [formGroupName]="j">
                                    <div [appDynamicClass]
                                    [key]="personfieldsForm?.value?.key"
                                    [allFields]="role?.get('personfields')?.value" *ngIf="personfieldsForm?.value?.is_enable" [formGroup]="personfieldsForm">
                                        <label for="name" [ngClass]="{'text-danger': (personfieldsForm.get('value')?.errors && (personfieldsForm?.touched || personfieldsForm?.dirty))}">
                                            <ng-container *ngTemplateOutlet="dynamicLabelTemplate; context:{form:personfieldsForm}"></ng-container>
                                        </label>
                                        @if(personfieldsForm?.value?.key === 'phone_no'){
                                            <ng-container *ngIf="(personfieldsForm?.value?.landcode | ipToCountry | async) as countryData">
                                                <ngx-intl-tel-input
                                                #personinput
                                                [customPlaceholder]="countryData?.calling_code"
                                                [enableAutoCountrySelect]="true"
                                                [enablePlaceholder]="true"
                                                [searchCountryFlag]="true"
                                                [selectFirstCountry]="false"
                                                [maxLength]="15"
                                                [phoneValidation]="enableRoleFeilds"
                                                name="phone"
                                                formControlName="value"
                                                [cssClass]="{'form-control country-input' : true, 'pointer-none' : !enableRoleFeilds}"
                                                [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                                                [selectFirstCountry]="false"
                                                [selectedCountryISO]="countryData?.countryCode"
                                                [disabled]="(personfieldsForm?.value?.lock ? true : false)"
                                                (countryChange)="onCountrySelected($event, personfieldsForm)"
                                            ></ngx-intl-tel-input>
                                          </ng-container>
                                        }
                                        @else {
                                            <input [mask]="(personfieldsForm?.value?.key === 'personal_id_number' && personfieldsForm?.value?.validation) ? '00000000-0000||000000-0000' : ''" [attr.id]="personfieldsForm?.value?.key" [attr.index]="i" autocomplete="off" [placeholder]="''" type="text" class="form-control" [ngClass]="{'pointer-none' : !enableRoleFeilds}" aria-describedby="templates-search" formControlName="value" #personinput [attr.readonly]="!enableRoleFeilds ? true : null"/>
                                        }
                                    </div>
                                </ng-container>
                            </div>
                        </ng-container>
                        <ng-container formArrayName="orgfields">
                            <div class="row">
                                <ng-container *ngFor="let orgfieldsForm of role?.get('orgfields')?.['controls']; let k = index" [formGroupName]="k">
                                    <div [appDynamicClass]
                                    [key]="orgfieldsForm?.value?.key"
                                    [allFields]="role?.get('orgfields')?.value" [formGroup]="orgfieldsForm" *ngIf="orgfieldsForm?.value?.is_enable" [formGroup]="orgfieldsForm">
                                        <label for="name" [ngClass]="{'text-danger': (orgfieldsForm.get('value')?.errors && (orgfieldsForm?.touched || orgfieldsForm?.dirty))}">
                                            <ng-container *ngTemplateOutlet="dynamicLabelTemplate; context:{form:orgfieldsForm}"></ng-container>
                                        </label>
                                        <input autocomplete="off" [placeholder]="''" type="text" class="form-control" [ngClass]="{'pointer-none' : !enableRoleFeilds}" aria-describedby="templates-search" formControlName="value" #personinput [attr.readonly]="!enableRoleFeilds ? true : null"/>
                                    </div>
                                </ng-container>
                            </div>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </form>
        </div>
    </div>
</ng-container>

<ng-template #dynamicLabelTemplate let-form="form">

  @if(form?.value?.is_default === 1 ){
        {{form?.value?.translation | dynamicLanguage | async}}
     }@else{
         {{form?.value?.name}}
     }

</ng-template>